import VueRouter from 'vue-router'
import Vue from 'vue'
import store from '../store'
import {getAction} from '@/api/tool'
import {api_user_info} from '@/api/api'
import Login from '@/pages/Login'
import AcceptTerms from '@/pages/AcceptTerms'
import Register from '@/pages/Register'
import ChangePassword from '@/pages/ChangePassword'
import TermNoEnter from '@/pages/TermNoEnter'
import Home from '@/pages/Home'
import Catalogue from '@/pages/Catalogue'
import GoodList from '@/pages/GoodList'
import Wishlist from '@/pages/Wishlist'
import WishlistDetail from '@/pages/WishlistDetail'
import Cart from '@/pages/Cart'
import Detail from '@/pages/Detail'
import Detail2 from '@/pages/Detail2'
import MyAccount from '@/pages/MyAccount'
import Address from '@/pages/Address'
import CustomerSupport from '@/pages/CustomerSupport'
import Term from '@/pages/Term'
import MyOrders from '@/pages/MyOrders'
import OrderDetail from '@/pages/OrderDetail'
import General from '@/pages/General'
import HasSendEmail from '@/pages/HasSendEmail'
import Guarantee from '@/pages/Guarantee'
import Transfer from '@/pages/Transfer'
import MyAccountStatement from '@/pages/MyAccountStatement'
import QuotesList from '@/pages/Quotes/List'
import QuotesDetail from '@/pages/Quotes/Detail'
import InvoiceList from '@/pages/Invoice/List'
import InvoiceDetail from '@/pages/Invoice/Detail'
import CreditNotesList from '@/pages/CreditNotes/List'
import CreditNotesDetail from '@/pages/CreditNotes/Detail'
import DebitNotesList from '@/pages/DebitNotes/List'
import DebitNotesDetail from '@/pages/DebitNotes/Detail'
import MyReceipt from '@/pages/MyReceipt'
import Shipment from '@/pages/Shipment/List'
import ShipmentDetail from '@/pages/Shipment/Detail'
import POS from '@/pages/POS'
import Opportunity from '@/pages/Opportunity'
import OpportunityDetail from '@/pages/Opportunity/Detail'
import OpportunityProductList from '@/pages/OpportunityProductList'
import Auth from '@/pages/Auth'
import NoAccess from '@/pages/NoAccess'

/* CQM相关的 */
import SelectRMAtype from '@/pages/RMA/SelectRMAtype'
import Enquiry from '@/pages/RMA/Enquiry'
import EnquiryDetail from '@/pages/RMA/EnquiryDetail'
import Commercial from '@/pages/RMA/Commercial'
import CommercialDetail from '@/pages/RMA/CommercialDetail'
import FieldFailuers from '@/pages/RMA/FieldFailuers'
import FieldFailuresDetail from '@/pages/RMA/FieldFailuresDetail'
import FailuresProd from '@/pages/RMA/FailuresProd'
import FailuresProdDetail from '@/pages/RMA/FailuresProdDetail'
import RMAList from '@/pages/RMA/RMAList'
import DraftsRMAlist from '@/pages/RMA/DraftsRMAlist'


const originalPush = VueRouter.prototype.push
VueRouter.prototype.push=function push(location){
  return originalPush.call(this,location).catch(err=>err)
}
/* 
  tokenVerify:有token,就不能进去的页面。（设置成true代表有token不能进去）
  mustLogin：没token，就不能进去的页面。(设置成true代表没token不能进去)
  mustSelectCountry：没有国家，不能进去的页面。（设置成true代表没国家不能进去）
  needRecord: 需要记录链接里的参数，带记忆功能的

  tokenVerify和mustLogin不能同时设置成true（可以同时false）
  mustLogin和mustSelectCountry不能同时设置成true（可以同时false）

  简单总结：tokenVerify只有登录页会用到。剩下的：mustLogin代表只能正常用户访问。mustSelectCountry代表访客也可以访问。
*/
const router = new VueRouter({
  routes:[
    //登录页面
    {
      name:'Login',
      path:'/login',
      component:Login,
      meta:{
        tokenVerify:true, //有token不能进入
        mustLogin:false, //没token可以进入
        mustSelectCountry:false //没国家可以进入
      }
    },
    //接受协议页面【正常用户】
    {
      name:'AcceptTerms',
      path:'/acceptTerms',
      component:AcceptTerms,
      meta:{
        mustLogin:true
      }
    },
    //注册页面【都可进】
    {
      name:'Register',
      path:'/register',
      component:Register
    },
    //修改密码页面【都可进】
    {
      name:'ChangePassword',
      path:'/changePassword',
      component:ChangePassword
    },
    //cookie条款【都可进】
    {
      name:'TermNoEnter',
      path:'/termNoEnter',
      component:TermNoEnter
    },
    //中转页面【都可进】
    {
      name:'Transfer',
      path:'/transfer',
      component:Transfer
    },
    //发送邮件后的提醒【都可进】
    {
      name:'HasSendEmail',
      path:'/hasSendEmail',
      component:HasSendEmail
    },
    //无权限提示页【都可进】：路由菜单权限校验不通过时跳到这里，不再放行到受控页面
    {
      name:'NoAccess',
      path:'/noAccess',
      component:NoAccess
    },
    /*
      登录之后的页面,能进入的话，mustLogin和mustSelectCountry必须设置其中的一个为true,并且只能一个为true。
    */
    {
      name:'Home',
      path:'/',
      component:Home,
      //这里必须直接跳到login而不是跳到catalogue页面的原因是:
      //如果该用户没有token，如果自动去到catalogue页面，那么会请求catalogue中的几个不必要请求的接口而导致报错token失效，比如获取产品一级目录的接口
      //注意，这里跳到login页面，和login页面的tokenVerify参数相互制约。所以说不存在有token但是又去到login页面的情况。因为有token，又去到login页面以后，又会被弹到catalogue的页面。
      redirect:'/login', 
      children:[
        //商品分类页面【访客也可以】
        {
          name:'Catalogue',
          path:'catalogue',
          component:Catalogue,
          meta:{
            mustSelectCountry:true,
            needRecord:true
          }
        },
        //商品列表页面【访客也可以】
        {
          name:'GoodList',
          path:'goodList',
          component:GoodList,
          meta:{
            mustSelectCountry:true,
            needRecord:true
          }
        },
        //商品详情页面【访客也可以】
        {
          name:'Detail',
          path:'detail',
          component:Detail,
          meta:{
            mustSelectCountry:true,
            needRecord:true
          }
        },
        {
          name:'Detail2',
          path:'detail2',
          component:Detail2,
          meta:{
            mustSelectCountry:true
          }
        },
        //我的收藏清单【正常用户】
        {
          name:'Wishlist',
          path:'wishlist',
          component:Wishlist,
          meta:{
            mustLogin:true
          }
        },
        //收藏详情【正常用户】
        {
          name:'WishlistDetail',
          path:'wishlistDetail',
          component:WishlistDetail,
          meta:{
            mustLogin:true
          }
        },
        //购物车页面【正常用户】
        {
          name:'Cart',
          path:'cart',
          component:Cart,
          meta:{
            mustLogin:true,
            needRecord:true
          }
        },
        //我的账户页面【正常用户】
        {
          name:'MyAccount',
          path:'myAccount',
          component:MyAccount,
          meta:{
            mustLogin:true,
            needRecord:true
          }
        },
        //地址【正常用户】
        {
          name:'Address',
          path:'address',
          component:Address,
          meta:{
            mustLogin:true,
            needRecord:true
          }
        },
        //客户支持【正常用户】
        {
          name:'CustomerSupport',
          path:'customerSupport',
          component:CustomerSupport,
          meta:{
            mustLogin:true
          }
        },
        //cookie条款【正常用户】
        {
          name:'Term',
          path:'term',
          component:Term,
          meta:{
            mustLogin:true
          }
        },
        //我的订单【正常用户】
        {
          name:'MyOrders',
          path:'myOrders',
          component:MyOrders,
          meta:{
            mustLogin:true,
            needRecord:true,
            keepAlive:true,
            hideFooter:true, //本页表格铺满视口剩余高度并内部滚动，文档不滚动，故不展示 Home 布局页脚
            menuRule:'C-MOR'
          }
        },
        //订单详情页【正常用户】
        {
          name:'OrderDetail',
          path:'orderDetail',
          component:OrderDetail,
          meta:{
            mustLogin:true,
            menuRule:'C-MOR'
          }
        },
        //我的发票【正常用户】
        {
          name:'InvoiceList',
          path:'invoiceList',
          component:InvoiceList,
          meta:{
            mustLogin:true,
            needRecord:true,
            menuRule:'C-MIV'
          }
        },
        //发票详情页【正常用户】
        {
          name:'InvoiceDetail',
          path:'invoiceDetail',
          component:InvoiceDetail,
          meta:{
            mustLogin:true,
            menuRule:'C-MIV'
          }
        },
        //我的销货【正常用户】
        {
          name:'Shipment',
          path:'shipment',
          component:Shipment,
          meta:{
            mustLogin:true,
            needRecord:true,
            keepAlive:false,
            menuRule:'C-MSP'
          }
        },
        //销货详情页【正常用户】
        {
          name:'ShipmentDetail',
          path:'shipmentDetail',
          component:ShipmentDetail,
          meta:{
            mustLogin:true,
            menuRule:'C-MSP'
          }
        },
        //我的报价单【正常用户】
        {
          name:'QuotesList',
          path:'quotesList',
          component:QuotesList,
          meta:{
            mustLogin:true,
            needRecord:true,
            menuRule:'C-MQO'
          }
        },
        //报价单详情页【正常用户】
        {
          name:'QuotesDetail',
          path:'quotesDetail',
          component:QuotesDetail,
          meta:{
            mustLogin:true,
            menuRule:'C-MQO'
          }
        },
        //实名认证
        {
          name:'Auth',
          path:'auth',
          component:Auth,
          meta:{
            mustLogin:true
          }
        },
        //我的收款通知单【正常用户】
        {
          name:'CreditNotesList',
          path:'creditNotesList',
          component:CreditNotesList,
          meta:{
            mustLogin:true,
            needRecord:true,
            menuRule:'C-MCN'
          }
        },
        //收款通知单详情页【正常用户】
        {
          name:'CreditNotesDetail',
          path:'creditNotesDetail',
          component:CreditNotesDetail,
          meta:{
            mustLogin:true,
            menuRule:'C-MCN'
          }
        },
        //我的付款通知单【正常用户】
        {
          name:'DebitNotesList',
          path:'debitNotesList',
          component:DebitNotesList,
          meta:{
            mustLogin:true,
            needRecord:true,
            menuRule:'C-MDN'
          }
        },
        //付款通知单详情页【正常用户】
        {
          name:'DebitNotesDetail',
          path:'debitNotesDetail',
          component:DebitNotesDetail,
          meta:{
            mustLogin:true,
            menuRule:'C-MDN'
          }
        },
        //我的对账单【正常用户】
        {
          name:'MyAccountStatement',
          path:'myAccountStatement',
          component:MyAccountStatement,
          meta:{
            mustLogin:true,
            needRecord:true,
            menuRule:'C-MAS'
          }
        },
        //我的收货单【正常用户】
        {
          name:'MyReceipt',
          path:'myReceipt',
          component:MyReceipt,
          meta:{
            mustLogin:true,
            needRecord:true,
            menuRule:'C-MRP'
          }
        },
        //我的收货单【正常用户】
        {
          name:'POS',
          path:'POS',
          component:POS,
          meta:{
            mustLogin:true,
            needRecord:true,
            menuRule:'C-MPD'
          }
        },
        //我的商机【正常用户】
        {
          name:'Opportunity',
          path:'opportunity',
          component:Opportunity,
          meta:{
            mustLogin:true,
            ouAccess:true, //My Opportunities 按 ou 白名单控制(与顶部菜单 showOpportunity 一致)
            needRecord:true,
            hideFooter:true, //本页不展示 Home 布局的底部页脚（分页固定在底部）
            keepAlive:true //缓存本页：面包屑回退/产品列表切回等入口进来不刷新，保持离开前状态；仅顶部菜单(query.from==='top')进入时在 activated 里重新初始化
          }
        },
        //商机详情/新增【正常用户】。id 为 New 时是新增，否则为商机编号（编辑）
        {
          name:'OpportunityDetail',
          path:'opportunityDetail/:id?',
          component:OpportunityDetail,
          meta:{
            mustLogin:true,
            ouAccess:true, //My Opportunities 按 ou 白名单控制(与顶部菜单 showOpportunity 一致)
            hideFooter:true //本页不展示 Home 布局的底部页脚（左右两列各自内部滚动、整页不滚动）
          }
        },
        //商机产品列表视图（从商机列表页“Switch to Product List View”进入，只有列表、无详情）【正常用户】
        {
          name:'OpportunityProductList',
          path:'opportunityProductList',
          component:OpportunityProductList,
          meta:{
            mustLogin:true,
            ouAccess:true, //My Opportunities 按 ou 白名单控制(与顶部菜单 showOpportunity 一致)
            needRecord:true,
            hideFooter:true //分页固定在底部，不展示 Home 布局页脚
          }
        },
        //通用条款【正常用户】
        {
          name:'General',
          path:'general',
          component:General,
          meta:{
            mustLogin:true,
            needRecord:true
          }
        },
        //QM-客诉页面
        {
          name:'Commercial',
          path:'commercial',
          component:Commercial,
          meta:{
            mustLogin:true
          }
        },
        {
          name:'Enquiry',
          path:'enquiry',
          component:Enquiry,
          meta:{
            mustLogin:true
          }
        },
        {
          name:'EnquiryDetail',
          path:'enquiryDetail',
          component:EnquiryDetail,
          meta:{
            mustLogin:true
          }
        },
        //QM-客诉页面
        {
          name:'FieldFailuers',
          path:'fieldFailuers',
          component:FieldFailuers,
          meta:{
            mustLogin:true
          }
        },
        {
          name:'FieldFailuresDetail',
          path:'fieldFailuresDetail',
          component:FieldFailuresDetail,
          meta:{
            mustLogin:true
          }
        },
        //QM-客诉页面
        {
          name:'FailuresProd',
          path:'failuresProd',
          component:FailuresProd,
          meta:{
            mustLogin:true
          }
        },
        {
          name:'FailuresProdDetail',
          path:'failuresProdDetail',
          component:FailuresProdDetail,
          meta:{
            mustLogin:true
          }
        },
        //我的RMA
        {
          name:'SelectRMAtype',
          path:'selectRMAtype',
          component:SelectRMAtype,
          meta:{
            mustLogin:true
          }
        },
        //我的RMA
        {
          name:'RMAList',
          path:'rmaList',
          component:RMAList,
          meta:{
            mustLogin:true
          }
        },
        //RMA-commercial详情
        {
          name:'CommercialDetail',
          path:'commercialDetail',
          component:CommercialDetail
        },
        {
          name:'Guarantee',
          path:'guarantee',
          component:Guarantee
        },
        //Drafts RMA
        {
          name:'DraftsRMAlist',
          path:'draftsRMAlist',
          component:DraftsRMAlist
        }
      ]
    }
  ]
})

/*
  菜单权限校验相关的辅助方法。
  背景：顶部菜单(Home/index.vue)用 userInfo.childMenuRules / ou 控制菜单项是否显示，
  但路由本身只校验了 token(mustLogin)，导致用户直接输入 URL 也能进入无权限的页面。
  这里在路由守卫里补一层“菜单权限”校验：路由 meta 声明 menuRule(对应 childMenuRules 的权限码)
  或 ouAccess(对应 My Opportunities 的 ou 白名单)，无权限时统一跳回商品分类页。
*/

/* 允许访问 My Opportunities 的 ou，必须与 Home/index.vue 的 showOpportunity 保持一致 */
const OPPORTUNITY_OU_WHITELIST = ['OU-GZ', 'OU-HK', 'OU-KR', 'OU-MY']

/* 缓存正在进行中的用户信息请求，避免并发时重复请求 */
let userInfoPromise = null

/*
  确保拿到用户信息：store 里已有就直接用；没有(例如直接刷新受权限控制的页面，
  App.vue 的异步请求还没回来)就主动请求一次并写入 store，避免误判为无权限。
*/
function ensureUserInfo(){
  let userInfo = store.state.userInfo
  if(userInfo && Object.keys(userInfo).length){
    return Promise.resolve(userInfo)
  }
  if(!userInfoPromise){
    userInfoPromise = getAction(api_user_info).then(res=>{
      store.dispatch('setUserInfo',res)
      store.dispatch('setCurrency',res.currency)
      store.dispatch('setArea',res.area)
      store.dispatch('setOU',res.ou)
      userInfoPromise = null
      return res
    }).catch(err=>{
      userInfoPromise = null
      return Promise.reject(err)
    })
  }
  return userInfoPromise
}

/* 判断用户对目标路由是否有菜单权限 */
function hasRoutePermission(userInfo,meta){
  if(meta.ouAccess){
    let ou = userInfo.ou
    return !ou || OPPORTUNITY_OU_WHITELIST.includes(ou)
  }
  if(meta.menuRule){
    let rules = userInfo.childMenuRules || []
    let need = Array.isArray(meta.menuRule) ? meta.menuRule : [meta.menuRule]
    return need.some(code => rules.includes(code))
  }
  return true
}

router.beforeEach((to,from,next)=>{
  let flag = false
  //注意：tokenVerify和mustLogin不可能同时设置成true。所以这两个if，最多只会去到一个，并不会两个if都进行判断。并且mustSelectCountry和mustLogin也不可能同时设置成true。
  //mustLogin说明只能正常用户访问，mustSelectCountry说明可以是访客访问。如果设置了mustLogin就绝对不会设置mustSelectCountry。如果设置了mustSelectCountry也绝对不会设置mustLogin。
  //并且登录之后的页面，除了协议页面之外。mustLogin和mustSelectCountry是必须选择一个设置的。
  //next()指定路径跳转时，要注意死循环的情况，要保证所有的逻辑路径都不会重叠!!!

  /* 去登录页或者带token的中转页面直接去，不要去乱跳 */
  if(to.name=='Login' || to.name=='Transfer'){
    next()
    return
  }
  /* 
    登录页特殊处理
    有token验证标记，并且有token，必须强制去主页。【比如，不能去登录页面。有token不能去登录页面!!!】
    这里不用在query里加Catalogue参数，因为这个是有token的情况
  */
  if(to.meta.tokenVerify && Vue.$cookies.get('token')){
    flag = true
    next({
      path:'/catalogue'
    })
  }
  /* 
    正常用户访问的页面
    有mustLogin验证标记，并且没有token，必须强制去登录页。【比如，不能去购物车页面】
    如果强制跳到login页面了，说明是需要先登陆进去的，那么就记录一下之前想过来的页面，然后再跳回去
  */
  if(to.meta.mustLogin && !Vue.$cookies.get('token')){
    flag = true
    //如果过来的页面本身就含有routeName参数的，那就说明，这个人虽然是想通过登录后直接进入到该页面，但是该页面又不允许这个客户进入，所以又只能强制到登录页面，那么这个时候就出现了一个死循环
    //比如，分享的链接是cart页面，到登录页的时候含参数?routeName=cart。选择国家后系统将跳到cart页面，但是cart页面又是不允许访客登录的，所以又无限循环回到了登录页面
    if(from.query.routeName){
      //说明进入了死循环，直接去首页，不要去登录页了
      next({
        path:'/catalogue'
      })
    }else{
      //第一次的时候记录下上一个页面的参数，选择国家后可直接进入
      let newQuery = {}
      if(to.needRecord){
        newQuery = to.query
        newQuery.routeName = to.path.split('/')[1]
      }
      next({
        path:'/login',
        query:newQuery
      })
    }
  }
  /* 
    访客访问的页面
    有mustSelectCountry验证标记，没有token，并且也没有select_country，并且链接中也不带国家，必须强制去登录页。【比如，不能去产品列表页面】
    如果强制跳到login页面了，说明是需要先选择国家进去的，那么就记录一下之前想过来的页面，然后再跳回去
  */
  if(to.meta.mustSelectCountry && !Vue.$cookies.get('token') && !Vue.$cookies.get('select_country') && !to.query.Catalogue){
    flag = true
    //这里不用跟上面写的一样if else那么复杂是因为，访客能进入的页面，登录过的用户一定能进入，所以没那么复杂。复杂的就在于有些普通用户能进入的页面访客不能进入
    let newQuery = {}
    if(to.needRecord){
      newQuery = to.query
      newQuery.routeName = to.path.split('/')[1]
    }
    next({
      path:'/login',
      query:newQuery
    })
  }
  /*
    菜单权限校验：仅在已登录、且前面分支都没触发跳转(flag 为 false)时才校验。
    路由声明了 menuRule / ouAccess 的，必须拥有对应权限，否则统一跳回商品分类页。
    这里用异步是因为刷新时 store.userInfo 可能还没被 App.vue 填充，需要先确保拿到用户信息。
  */
  if(!flag && (to.meta.menuRule || to.meta.ouAccess) && Vue.$cookies.get('token')){
    flag = true
    ensureUserInfo().then(userInfo=>{
      if(hasRoutePermission(userInfo,to.meta)){
        next()
      }else{
        next({
          path:'/noAccess'
        })
      }
    }).catch(()=>{
      //拿不到用户信息(例如 token 失效，tool.js 已跳登录页)，这里兜底不放行到受控页面
      next({
        path:'/noAccess'
      })
    })
  }
  /* 
    如果以上两种情况都不满足，那么就直接到下一页就可以了，说明是正常的情况
  */
  if(!flag){
    next()
  }
})

export default router
